import {Controller} from 'stimulus'
import Swiper, {Navigation, Pagination, EffectFade} from 'swiper'

Swiper.use([Navigation, Pagination, EffectFade])

export default class extends Controller {

  connect() {
    this.initSlider()
  }

  initSlider() {
    new Swiper('.js-storiesSlider', {
      slidesPerView: 1,
      loop: true,
      speed: 350,
      effect: 'fade',
      threshold: 35,
      autoHeight: true,
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        700: {
          threshold: 70,
        },
        1024: {
          threshold: 100,
        }
      }
    })
  }

}
